export const dismissButton = (title = 'Ok') => ({
  title: title,
  action: ['DISMISS']
});

export const goToButton = (title, location) => ({
  title: title,
  action: ['GOTO', location]
});

export const dispatchButton = (title, action) => ({
  title,
  action: ['DISPATCH', action]
});
